import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { z } from 'zod';

import { UnusedFee } from './UnusedFee';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';

const RouteParamsStruct = z.object({
  counterpartySlug: z.string({ message: 'Missing counterpartySlug' }),
});

export const Route = () => {
  const params = useParams();
  // TODO counterpartySlug is the temporary id for expenses. add new id for each expense - https://linear.app/finleycms/issue/ENG-14782/create-a-new-identifier-for-each-expense - @markhaghani
  const { counterpartySlug } = RouteParamsStruct.parse(params);

  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/settings/implementations/" />;
      }}
    >
      <UnusedFee counterpartySlug={counterpartySlug} />
    </RouteErrorBoundary>
  );
};
